import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../store/auth-context';
import { hasAccess } from '../config/roles';

interface ProtectedRouteProps {
    requiredRoles: string[];
    requireDashboard?: boolean;
}

const ProtectedRoute = ({ requiredRoles, requireDashboard }: ProtectedRouteProps) => {
    const authCtx = useContext(AuthContext);

    if (!hasAccess(authCtx.user?.role, requiredRoles)) {
        return <Navigate to="/" replace />;
    }

    if (requireDashboard && !authCtx.dashboardEnabled) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
